var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaymentIconVisaColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.58 21H2.42A2.4 2.4 0 010 18.62V4.38A2.4 2.4 0 012.42 2h24.16A2.4 2.4 0 0129 4.38v14.25A2.4 2.4 0 0126.58 21z",
    fill: "#F6F9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18v.63A2.4 2.4 0 002.42 21h24.16A2.4 2.4 0 0029 18.62V18H0z",
    fill: "#F99F1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5v-.63A2.4 2.4 0 012.42 2h24.16A2.4 2.4 0 0129 4.38V5H0zm13.9 3.12l-1.48 6.77h-1.77l1.46-6.77h1.78zm7.47 4.38l.94-2.55.54 2.55h-1.48zm1.99 2.4H25l-1.44-6.78h-1.51a.8.8 0 00-.76.5l-2.67 6.27h1.87l.37-1h2.28l.22 1zm-4.64-2.22c0-1.78-2.51-1.88-2.5-2.68.01-.24.25-.5.76-.57a3.4 3.4 0 011.75.3l.31-1.43c-.42-.15-.97-.3-1.66-.3-1.76 0-3 .92-3 2.24-.01.97.88 1.52 1.55 1.84.7.33.93.55.93.84-.01.46-.56.66-1.07.66-.9.02-1.41-.23-1.82-.42l-.33 1.48c.42.19 1.19.35 1.98.36 1.87 0 3.09-.9 3.1-2.32zm-7.37-4.56L8.47 14.9H6.6L5.18 9.5c-.09-.33-.17-.45-.43-.6A7.53 7.53 0 003 8.33l.04-.2h3.03c.38 0 .73.26.82.7l.75 3.91 1.85-4.6h1.86z",
    fill: "#2D4990"
  })));
}

export default SvgPaymentIconVisaColor;